import React from 'react';

import ActionButton from '../ActionButton';
import useAsyncAction from '../../hooks/useAsyncAction';
import './styles.scss';

type Props = {
	cps?: string;
	linked?: boolean;
	onGetAccountRecovery?: () => void | Promise<void>;
};

const ALLOWED_CP_ACCOUNT_RECOVERY_FLOW = ['netflix'];

const AccountRecovery: React.FC<Props> = ({ cps, linked, onGetAccountRecovery }) => {
	const { isLoading, errorMessage, run } = useAsyncAction(
		onGetAccountRecovery,
		'Error al recuperar la cuenta. Por favor, intenta nuevamente.'
	);

	if (!ALLOWED_CP_ACCOUNT_RECOVERY_FLOW.includes(cps!) || !linked) return null;

	return (
		<div className="account-recovery">
			<div className="recovery-content">
				<div className="message-inner">
					<p className="message-line">Si no recuerdas tu cuenta haz clic en Recuperar Cuenta para ver los datos de inicio de sesión</p>
				</div>

				<ActionButton
					label="Recuperar cuenta"
					onClick={run}
					isLoading={isLoading}
					disabled={!onGetAccountRecovery}
				/>
			</div>
			{errorMessage && (
				<p className="error-message">{errorMessage}</p>
			)}
		</div>
	);
};

export default AccountRecovery;
